import Client from '@/apis/liff/Chatroom'
import { state, mutations, getters, actions } from './base'

// as_staff 以 session cookie 持久化（不設 expires，關閉瀏覽器即清除），per-org 避免跨組織誤判
function asStaffCookieName(orgCode) {
  return `liff_as_staff_${orgCode || 'unknown'}`
}

function writeAsStaffCookie(orgCode, bool) {
  const name = asStaffCookieName(orgCode)
  if (bool) {
    document.cookie = `${name}=1; path=/`
  } else {
    // 設定過去時間以刪除 cookie
    document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`
  }
}

function readAsStaffCookie(orgCode) {
  const name = asStaffCookieName(orgCode)
  return document.cookie.split('; ').some((c) => c === `${name}=1`)
}

export default {
  namespaced: true,
  state: {
    ...state(),
    shouldCheckFollowStatus: false,
    asStaff: false,
  },
  mutations: {
    ...mutations(),
    SET_AS_STAFF(state, bool) {
      state.asStaff = bool
    }
  },
  getters: getters(),
  actions: {
    ...actions(Client),
    setAsStaff({ commit, state }, bool) {
      commit('SET_AS_STAFF', bool)
      // 同步寫入 session cookie，使內部導航與重新載入皆不需依賴 query 傳遞
      writeAsStaffCookie(state.orgCode, bool)
    },
    hydrateAsStaff({ commit, state }) {
      // query 缺席時由 cookie 還原 staff 身份
      if (readAsStaffCookie(state.orgCode)) {
        commit('SET_AS_STAFF', true)
      }
    },
    async fetchUser ({ commit, state }) {
      commit('SET_USER', await Client.getInstance().getCustomer({ asStaff: state.asStaff }))
    },
    getChatrooms ({ state }, { page, count, status, keyword } = {}) {
      return Client.getInstance().getChatrooms({asStaff: state.asStaff, page, count, status, keyword})
    },
    getChatroom ({ state }, { chatroomId }) {
      return Client.getInstance().getChatroom({ chatroomId, asStaff: state.asStaff })
    },
    getMessages ({ state }, { chatroomId, cursor, count = 50, keyword }) {
      return Client.getInstance().getMessages({ chatroomId, cursor, count, asStaff: state.asStaff, keyword })
    },
    pinChatroom ({ state }, { chatroomId }) {
      return Client.getInstance().pinChatroom({ chatroomId, asStaff: state.asStaff })
    },
    unpinChatroom ({ state }, { chatroomId }) {
      return Client.getInstance().unpinChatroom({ chatroomId, asStaff: state.asStaff })
    },
    updateChatroomStatus ({ state }, { chatroomId, status }) {
      return Client.getInstance().updateChatroomStatus({ chatroomId, status, asStaff: state.asStaff })
    },
    recallMessages ({ state }, { chatroomId, recallMessages }) {
      return Client.getInstance().recallMessages({ chatroomId, recallMessages, asStaff: state.asStaff })
    },
    getDoNotDisturb ({ state }, { chatroomId }) {
      return Client.getInstance().getDoNotDisturb({ chatroomId, asStaff: state.asStaff })
    },
    updateDoNotDisturb ({ state }, { chatroomId, action, notDisturbUntil }) {
      return Client.getInstance().updateDoNotDisturb({ chatroomId, action, notDisturbUntil, asStaff: state.asStaff })
    },
    sendMessage (_, { chatroomId, message, state }) {
      return Client.getInstance().sendMessage({ chatroomId, message, state, asStaff: _.state.asStaff })
    },
    markAsRead (_, { chatroomId }) {
      return Client.getInstance().markAsRead({ chatroomId, asStaff: _.state.asStaff })
    },
    goToChat (_, { sourceType, sourceId, chatroomId = null }) {
      return Client.getInstance().goToChat({ sourceType, sourceId, chatroomId })
    },
    goToChatStaff (_, { sourceType, sourceId, skuId }) {
      return Client.getInstance().goToChatStaff({ sourceType, sourceId, skuId })
    },
    upload ({ state }, { chatroomId, files }) {
      return Client.getInstance().upload({ chatroomId, files, asStaff: state.asStaff })
    },
    markAsUploaded ({ state }, { chatroomId, state: uploadState, files }) {
      return Client.getInstance().markAsUploaded({ chatroomId, state: uploadState, files, asStaff: state.asStaff })
    },
    getConfig() {
      return Client.getInstance().getConfig()
    },
    generateMultipleUploadToken (_, { payload }) {
      return Client.getInstance().generateMultipleUploadToken({ payload })
    },
  }
}
